var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboard-main-content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-12" }, [
          _c(
            "div",
            { staticClass: "form-box" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "v-app",
                [
                  _c("div", { staticClass: "card-item p-3" }, [
                    _c("div", { staticClass: "contact-form-action" }, [
                      _c(
                        "div",
                        { staticClass: "input-box" },
                        [
                          _c("label", { staticClass: "label-text" }, [
                            _vm._v("Sefer :"),
                          ]),
                          _vm._v(" "),
                          _c("v-autocomplete", {
                            attrs: {
                              items: _vm.sailList,
                              onchange: _vm.onSailSelected,
                              flat: "",
                              "hide-no-data": "",
                              "menu-props": { nudgeTop: 110, maxHeight: 175 },
                              "hide-details": "",
                              "item-value": "id",
                              placeholder: "Sefer",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "selection",
                                fn: function (ref) {
                                  var item = ref.item
                                  var selected = ref.selected
                                  return [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm._f("ddMMyyyy")(item.sailDate)
                                        ) +
                                        "\n                      "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item",
                                fn: function (ref) {
                                  var item = ref.item
                                  var tile = ref.tile
                                  return [
                                    _c("v-list-tile-content", [
                                      _vm._v(
                                        "\n                          " +
                                          _vm._s(
                                            _vm._f("ddMMyyyy")(item.sailDate)
                                          ) +
                                          "\n                        "
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                            model: {
                              value: _vm.selectedSail,
                              callback: function ($$v) {
                                _vm.selectedSail = $$v
                              },
                              expression: "selectedSail",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.agencyList, function (agency) {
                    return _vm.agencyProformas &&
                      _vm.selectedSail &&
                      _vm.agencyList
                      ? _c(
                          "div",
                          { staticClass: "form-content pb-2" },
                          [
                            _c("div", { staticClass: "form-title-wrap" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-items-center justify-content-between",
                                },
                                [
                                  _c("h3", { staticClass: "title" }, [
                                    _vm._v(_vm._s(agency.name)),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "theme-btn",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.createNewProforma(
                                            agency.id
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Yeni Proforma Fatura Üret")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "row",
                                    staticStyle: { "padding-bottom": "1px" },
                                  },
                                  [
                                    _c("p", { staticClass: "booking-count" }, [
                                      _c("b", [_vm._v("Rezervasyon")]),
                                      _vm._v(
                                        " : " + _vm._s(agency.bookingCount)
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "booking-count" }, [
                                      _c("b", [_vm._v("Oda")]),
                                      _vm._v(" : ?"),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "booking-count" }, [
                                      _c("b", [_vm._v("Yolcu")]),
                                      _vm._v(" : ?"),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("v-data-table", {
                              staticClass: "elevation-1",
                              attrs: {
                                headers: _vm.headers,
                                items: _vm.filterProformasByAgencyIdAndSailId(
                                  agency.id,
                                  _vm.selectedSail
                                ),
                                "items-per-page": 5,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "item.id",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c("th", [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href:
                                                  _vm.basePath +
                                                  "/proforma-detail/" +
                                                  item.id,
                                              },
                                            },
                                            [_vm._v("#" + _vm._s(item.id))]
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.createDate",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c("tr", [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm._f("ddMMyyyyHHmmSS")(
                                                  item.createDate
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.sailId",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c("tr", [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm._f("ddMMyyyy")(
                                                  _vm.sailsLiteMap[item.sailId]
                                                    .sailDate
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.agencyId",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c("tr", [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.agencyMap[item.agencyId]
                                                  .name
                                              ) +
                                              "\n                    "
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.edit",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "table-content" },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "theme-btn theme-btn-small",
                                                staticStyle: { color: "white" },
                                                attrs: {
                                                  href: "javascript:void(0)",
                                                  "data-toggle": "tooltip",
                                                  "data-placement": "top",
                                                  title: "",
                                                  "data-original-title": "Edit",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.downloadProforma(
                                                      item.documentStoreId
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "la la-download",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        )
                      : _vm._e()
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-title-wrap" }, [
      _c(
        "div",
        { staticClass: "d-flex align-items-center justify-content-between" },
        [_c("h3", { staticClass: "title" }, [_vm._v("Acente")])]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }